import React, { Fragment, useState, useEffect } from 'react'
import moment from 'moment'
import { makeStyles } from '@material-ui/styles'
import {
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  InputAdornment,
} from '@material-ui/core'
import { Alert, Pagination } from '@material-ui/lab'
import DateFnsUtils from '@date-io/date-fns'
import {
  DatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import TransactionApi from '@api/Transaction'
import { thousandFormat } from '@services/Format/Currency'
import { defaultDate } from '@services/Format/Date'
import { ReactComponent as SearchIcon } from '@assets/images/svg/search.svg'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '1.5rem 2rem',
    background: '#fff',
    borderRadius: 10,
    marginBottom: '2rem',
    '& p': {
      fontWeight: 600,
      lineHeight: '27px',
    },
  },
  table: {
    marginTop: '0.625rem',
    paddingBottom: '2rem',
  },
  percentage: {
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
  searchField: {
    '& .MuiInputBase-root': {
      padding: '0.375rem 0.75rem',
      border: '1px solid #C4C4C4',
      borderRadius: 5,
    },
    '& .MuiInputAdornment-positionStart': {
      paddingBottom: 0,
    },
    '& .MuiInputBase-input': {
      height: 'auto',
      padding: 0,
    },
  },
  dateField: {
    '& .MuiInputBase-root': {
      padding: '0.375rem 0.75rem',
      border: '1px solid #C4C4C4',
      borderRadius: 5,
      width: 170,
      marginRight: '1rem',
    },
    '& .MuiInputBase-input': {
      height: 'auto',
      padding: 0,
    },
  },
  filterForm: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: '1rem',
  },
  loading: {
    padding: '1rem',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  resetButton: {
    fontSize: '0.875rem',
    height: 38,
  },
}))

const TableReferral = ({ lastRequest, token }) => {
  const classes = useStyles()
  const [loading, setLoading] = useState(true)
  const [transactions, setTransactions] = useState()
  const [name, setName] = useState()
  const [page, setPage] = useState(1)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)

  const fetchTransaction = () => {
    setLoading(true)
    TransactionApi.index(
      token,
      page,
      name,
      {
        startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : '',
        endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : '',
      },
    )
      .then((res) => {
        setTransactions(res)
        setLoading(false)
      })
  }

  const resetFilter = () => {
    setStartDate(null)
    setEndDate(null)
    setName()
  }

  useEffect(() => {
    fetchTransaction()
  }, [page, lastRequest, name, startDate, endDate])

  return (
    <div className={classes.root}>
      <p>Data Transaksi Referral</p>
      <div className={classes.filterForm}>
        <TextField
          placeholder="Cari nama atau toko"
          onChange={(e) => setName(e.target.value)}
          className={classes.searchField}
          InputProps={{
            startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
          }}
          variant="outlined"
        />
        <div>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              value={startDate}
              placeholder="Dari tanggal"
              format="dd/MM/yyyy"
              onChange={setStartDate}
              className={classes.dateField}
            />
            <DatePicker
              value={endDate}
              placeholder="Sampai tanggal"
              minDate={startDate || new Date()}
              format="dd/MM/yyyy"
              onChange={setEndDate}
              className={classes.dateField}
            />
            <Button
              color="primary"
              variant="contained"
              className={classes.resetButton}
              onClick={() => resetFilter()}
            >
              Reset
            </Button>
          </MuiPickersUtilsProvider>
        </div>
      </div>
      {!loading ? (
        <Fragment>
          {transactions && transactions.data?.length > 0 ? (
            <Fragment>
              <TableContainer className={classes.table}>
                <Table className={classes.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>No</TableCell>
                      <TableCell>Nama</TableCell>
                      <TableCell>Toko</TableCell>
                      <TableCell>Paket</TableCell>
                      <TableCell>Terdaftar Pada</TableCell>
                      <TableCell>Dibayar Pada</TableCell>
                      <TableCell>Total Bayar</TableCell>
                      <TableCell>Komisi</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {transactions.data.map((transaction, index) => (
                      <TableRow key={transaction.id}>
                        <TableCell>{(((page - 1) * 10) + (index + 1))}</TableCell>
                        <TableCell>{transaction.saas_user_name}</TableCell>
                        <TableCell>{transaction.store_name}</TableCell>
                        <TableCell>{transaction.package_name}</TableCell>
                        <TableCell>{defaultDate(transaction.created_at)}</TableCell>
                        <TableCell>{transaction.invoice_date}</TableCell>
                        <TableCell>Rp. {thousandFormat(`${parseInt(transaction.amount, 10)}`)}</TableCell>
                        <TableCell>
                          Rp. {thousandFormat(`${parseInt(transaction.commission, 10)}`)}&nbsp;
                          (<span className={classes.percentage}>{transaction.formated.commission_percentage}</span>)
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Pagination
                count={transactions.pagination.total_pages}
                page={page}
                onChange={(_event, value) => setPage(value)}
                shape="rounded"
              />
            </Fragment>
          ) : (
            <Alert variant="outlined" severity="warning">
              Data yang di cari masih kosong / tidak ditemukan
            </Alert>
          )}
        </Fragment>
      ) : (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      )}
    </div>
  )
}

export default TableReferral
